<template>
    <transition-group class="container-products" tag="section" name="fade-in-right-group" mode="out-in" :style="{'--total': familyProducts.lenght}">
      <ProductLayout v-for="products in familyProducts" :key="products.id" :products="products"/>
    </transition-group>
</template>

<script>
import ProductLayout from '../components/ProductLayout.vue'
import FamiliasProductosService from '@/services/FamiliasProductosService'
import { EventBus } from '@/event-bus'
export default {
  name: 'products',
  components: {
    ProductLayout
  },
  data () {
    return {
      familyProducts: []
    }
  },
  computed: {},
  methods: {
    getFamilias () {
      const service = new FamiliasProductosService()
      service.findAll((response) => {
        response.forEach(r => {
          this.familyProducts.push(FamiliasProductosService.parse(r))
        })
      })
    }
  },
  mounted () {
    EventBus.$emit('showTitlePage', this.$t('products.pageTitle'))
    EventBus.$emit('toggleHeaderFamilyIcons', false)
    this.getFamilias()
  },
  watch: {
    '$i18n.locale': {
      handler () {
        EventBus.$emit('showTitlePage', this.$t('products.pageTitle'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .container-products{
    position: relative;
    background: #1A1A1A;
    // padding-block: 6rem 1rem;
    padding-inline: var(--main-space);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1.5em;
    padding-top: calc(var(--main-space) * 4);
  }
  @include media-breakpoint-down(sm) {
    .container-products{
      padding-top: 120px;
    }
  }
</style>
